module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "works-box",
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-info box-info-inline"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-info box-info-inline"
  }, [_c('label', {
    staticClass: "label-inline"
  }, [_vm._v("参赛组别：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.convertGrade(_vm.work.gid)))])]), _vm._v(" "), _c('div', {
    staticClass: "box-info box-info-inline"
  }, [_c('label', {
    staticClass: "label-inline"
  }, [_vm._v("作品名称：")]), _vm._v(" "), _c('el-input', {
    staticClass: "box-info el-input-mid",
    attrs: {
      "disabled": "",
      "placeholder": "请输入作品名称"
    },
    model: {
      value: (_vm.work.name),
      callback: function($$v) {
        _vm.$set(_vm.work, "name", $$v)
      },
      expression: "work.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box-info box-info-inline"
  }, [_c('label', {
    staticClass: "label-inline"
  }, [_vm._v("指导老师：")]), _vm._v(" "), _c('el-input', {
    staticClass: "box-info",
    attrs: {
      "disabled": "",
      "placeholder": "指导老师（多个老师以；分割）"
    },
    model: {
      value: (_vm.work.teacher),
      callback: function($$v) {
        _vm.$set(_vm.work, "teacher", $$v)
      },
      expression: "work.teacher"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box-info label-block"
  }, [_vm._v("指导老师点评：")]), _vm._v(" "), _c('el-input', {
    staticClass: "box-info box-info-textarea",
    attrs: {
      "disabled": "",
      "rows": "5",
      "type": "textarea",
      "maxlength": "300",
      "show-word-limit": "",
      "placeholder": "请输入指导老师点评（ 不超过300个字）"
    },
    model: {
      value: (_vm.work.teacher_comment),
      callback: function($$v) {
        _vm.$set(_vm.work, "teacher_comment", $$v)
      },
      expression: "work.teacher_comment"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-info label-block"
  }, [_vm._v("作品设计说明：")]), _vm._v(" "), _c('el-input', {
    staticClass: "box-info box-info-textarea",
    attrs: {
      "type": "textarea",
      "rows": "8",
      "minlength": "200",
      "maxlength": "1000",
      "show-word-limit": "",
      "placeholder": "作品设计说明，表达设计思路或设计理念（ 不少于200字，不多于1,000个字）"
    },
    model: {
      value: (_vm.work.note),
      callback: function($$v) {
        _vm.$set(_vm.work, "note", $$v)
      },
      expression: "work.note"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-info label-block"
  }, [_vm._v("作品封面上传：")]), _vm._v(" "), _c('el-upload', {
    staticClass: "works-up box-info",
    class: {
      coverDisabled: _vm.coverIsMax
    },
    attrs: {
      "action": _vm.url + '/api/upload/json/',
      "headers": _vm.headers,
      "list-type": "picture-card",
      "limit": 1,
      "accept": "image/jpeg,image/png,image/jpg",
      "file-list": _vm.coverList,
      "on-success": _vm.handleSuccess.bind(this, 'cover'),
      "on-error": _vm.handleError.bind(this, 'cover'),
      "on-change": _vm.handleChange.bind(this, 'cover'),
      "on-remove": _vm.handleRemove.bind(this, 'cover'),
      "on-preview": _vm.handleCoverPreview,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('i', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("上传作品封面")]), _vm._v("（"), _c('i', {
    staticStyle: {
      "color": "red",
      "font-size": "13px"
    }
  }, [_vm._v("必填")]), _vm._v("）"), _c('br'), _c('i', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("JPG格式，大小不超过1M"), _c('br'), _vm._v("尺寸要求2000x2000px")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogCoverVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogCoverVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogCoverUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-info label-block"
  }, [_vm._v("作品任务书上传：")]), _vm._v(" "), _c('el-upload', {
    staticClass: "works-up box-info",
    class: {
      specDisabled: _vm.specIsMax
    },
    attrs: {
      "action": _vm.url + '/api/upload/json/',
      "headers": _vm.headers,
      "list-type": "picture-card",
      "limit": 1,
      "disabled": "",
      "accept": "image/jpeg,image/png,image/jpg",
      "file-list": _vm.specList,
      "on-success": _vm.handleSuccess.bind(this, 'spec'),
      "on-error": _vm.handleError.bind(this, 'spec'),
      "on-change": _vm.handleChange.bind(this, 'spec'),
      "on-remove": _vm.handleRemove.bind(this, 'spec'),
      "on-preview": _vm.handleSpecPreview,
      "before-upload": _vm.beforeImageUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('i', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("上传作品任务书")]), _vm._v("（"), _c('i', {
    staticStyle: {
      "color": "red",
      "font-size": "13px"
    }
  }, [_vm._v("必填")]), _vm._v("）"), _c('br'), _c('i', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("JPG/PNG格式，大小不超过2M"), _c('br'), _vm._v("尺寸小于4000x4000")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogSpecVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogSpecVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogSpecUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-info label-block"
  }, [_vm._v("作品图纸上传：")]), _vm._v(" "), (_vm.work.channel === '2') ? _c('div', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("2~5张图纸：")]) : _vm._e(), _vm._v(" "), _c('el-upload', {
    staticClass: "works-up box-info",
    class: {
      imageDisabled: _vm.imageIsMax
    },
    attrs: {
      "action": _vm.url + '/api/upload/json/',
      "headers": _vm.headers,
      "list-type": "picture-card",
      "limit": 5,
      "accept": "image/jpeg,image/png,image/jpg",
      "file-list": _vm.imgsList,
      "on-preview": _vm.handlePictureCardPreview,
      "on-success": _vm.handleSuccess.bind(this, 'image'),
      "on-error": _vm.handleError.bind(this, 'image'),
      "on-change": _vm.handleChange.bind(this, 'image'),
      "on-remove": _vm.handleRemove.bind(this, 'image'),
      "on-exceed": _vm.handleImageExceed.bind(this, 'image'),
      "before-upload": _vm.beforeImageUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), (_vm.work.channel === '2') ? _c('div', {
    staticClass: "el-upload__text"
  }, [_c('i', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("上传图纸图片")]), _vm._v("（"), _c('i', {
    staticStyle: {
      "color": "red",
      "font-size": "13px"
    }
  }, [_vm._v("必填")]), _vm._v("）"), _c('br'), _c('i', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("JPG格式，大小不超过2M"), _c('br'), _vm._v("A2横版")])]) : _c('div', {
    staticClass: "el-upload__text"
  }, [_c('i', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("上传图纸图片")]), _vm._v("（"), _c('i', {
    staticStyle: {
      "color": "red",
      "font-size": "13px"
    }
  }, [_vm._v("必填")]), _vm._v("）"), _c('br'), _c('i', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("JPG格式，大小不超过2M"), _c('br'), _vm._v("每张尺寸为A2横版"), _c('br'), _vm._v("可上传2-5张")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.work.channel === '2') ? [_c('div', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("1~2张实体模型照片：")]), _vm._v(" "), _c('el-upload', {
    staticClass: "works-up box-info",
    class: {
      imageDisabled: _vm.image2IsMax
    },
    attrs: {
      "action": _vm.url + '/api/upload/json/',
      "headers": _vm.headers,
      "list-type": "picture-card",
      "limit": 2,
      "accept": "image/jpeg,image/png,image/jpg",
      "file-list": _vm.imgs2List,
      "on-preview": _vm.handlePictureCardPreview,
      "on-success": _vm.handleSuccess.bind(this, 'image2'),
      "on-error": _vm.handleError.bind(this, 'image2'),
      "on-change": _vm.handleChange.bind(this, 'image2'),
      "on-remove": _vm.handleRemove.bind(this, 'image2'),
      "on-exceed": _vm.handleImageExceed.bind(this, 'image2'),
      "before-upload": _vm.beforeImageUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('i', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("上传实体模型图片")]), _vm._v("（"), _c('i', {
    staticStyle: {
      "color": "red",
      "font-size": "13px"
    }
  }, [_vm._v("必填")]), _vm._v("）"), _c('br'), _c('i', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("JPG格式，大小不超过2M"), _c('br'), _vm._v("每张尺寸为A2横版"), _c('br'), _vm._v("可上传1-2张")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogImage2Visible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogImage2Visible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImage2Url,
      "alt": ""
    }
  })])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-info label-block"
  }, [_vm._v("作品视频上传：")]), _vm._v(" "), _c('el-upload', {
    staticClass: "works-up box-info video-works-up",
    class: {
      videoDisabled: _vm.videoIsMax
    },
    attrs: {
      "action": _vm.url + '/api/upload/json/',
      "headers": _vm.headers,
      "list-type": "picture-card",
      "limit": 1,
      "accept": "video/mp4",
      "file-list": _vm.videosList,
      "on-success": _vm.handleSuccess.bind(this, 'video'),
      "on-error": _vm.handleError.bind(this, 'video'),
      "on-change": _vm.handleChange.bind(this, 'video'),
      "on-remove": _vm.handleRemove.bind(this, 'video'),
      "on-exceed": _vm.handleVideoExceed,
      "before-upload": _vm.beforeVideoUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('i', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("上传作品视频")]), _vm._v("（"), _c('i', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("选填")]), _vm._v("）"), _c('br'), _c('i', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("MP4格式，不超过100M"), _c('br'), _vm._v("时长不超过2分钟")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-info box-info-inline"
  }, [_vm._m(1), _vm._v(" "), _c('el-select', {
    staticClass: "cselect",
    attrs: {
      "disabled": "",
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.work.audience),
      callback: function($$v) {
        _vm.$set(_vm.work, "audience", $$v)
      },
      expression: "work.audience"
    }
  }, _vm._l((_vm.audiences), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.label
      }
    })
  }), 1), _vm._v(" "), (_vm.work.audience == '其他') ? _c('el-input', {
    staticClass: "el-input-small",
    attrs: {
      "disabled": "",
      "placeholder": "请输入作品功能内容分类"
    },
    model: {
      value: (_vm.work.audienceOther),
      callback: function($$v) {
        _vm.$set(_vm.work, "audienceOther", $$v)
      },
      expression: "work.audienceOther"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-info box-info-inline"
  }, [_vm._m(2), _vm._v(" "), _c('el-select', {
    staticClass: "cselect",
    attrs: {
      "disabled": "",
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.work.env),
      callback: function($$v) {
        _vm.$set(_vm.work, "env", $$v)
      },
      expression: "work.env"
    }
  }, _vm._l((_vm.envs), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.label
      }
    })
  }), 1), _vm._v(" "), (_vm.work.env == '其他') ? _c('el-input', {
    staticClass: "el-input-small",
    attrs: {
      "disabled": "",
      "placeholder": "请输入作品地形环境分类"
    },
    model: {
      value: (_vm.work.envOther),
      callback: function($$v) {
        _vm.$set(_vm.work, "envOther", $$v)
      },
      expression: "work.envOther"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-info box-info-inline"
  }, [_vm._m(3), _vm._v(" "), _c('el-select', {
    staticClass: "cselect",
    attrs: {
      "disabled": "",
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.work.area),
      callback: function($$v) {
        _vm.$set(_vm.work, "area", $$v)
      },
      expression: "work.area"
    }
  }, _vm._l((_vm.areas), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.label
      }
    })
  }), 1), _vm._v(" "), (_vm.work.area == '其他') ? _c('el-input', {
    staticClass: "el-input-small",
    attrs: {
      "disabled": "",
      "placeholder": "请输入作品面积分类"
    },
    model: {
      value: (_vm.work.areaOther),
      callback: function($$v) {
        _vm.$set(_vm.work, "areaOther", $$v)
      },
      expression: "work.areaOther"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-button', {
    staticClass: "primary-btn",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("确定修改")])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title_wrap"
  }, [_c('span', {
    staticClass: "title_name"
  }, [_vm._v("作品修改")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-inline-long"
  }, [_vm._v("作品功能内容分类（"), _c('i', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("必填")]), _vm._v("）：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-inline-long"
  }, [_vm._v("作品地形环境分类（"), _c('i', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("必填")]), _vm._v("）：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-inline-long"
  }, [_vm._v("作品针对面积分类（"), _c('i', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("必填")]), _vm._v("）：")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-400dee7d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/WorkDetailUpdate.vue
// module id = 618
// module chunks = 1